export default __webpack_public_path__ + "static/media/trustVibe.edd93d22.svg";